<template>
  <div class="layout-menu">
    <div class="upper-content">
      <div class="flex justify-between p-8">
        <a class="logo-image" href="/"
          ><img loading="lazy" src="/img/logo-white.png" alt="logo-icon"
        /></a>
        <div class="menu-close">
          <button v-on:click="closeMenu" class="cross">&times;</button>
        </div>
      </div>
      <ul class="list">
        <li class="list-item">
          <a class="list-item__text" :href="routes['shop']+'/feminized-seeds'"><span>{{ trans.get('mobile-menu.feminized') }}</span></a>
        </li>
        <li class="list-item">
          <a class="list-item__text" :href="routes['shop']+'/autoflower-seeds'"><span>{{ trans.get('mobile-menu.autoflower') }}</span></a>
        </li>
        <li class="list-item">
          <a class="list-item__text" :href="routes['shop']+'/seed-collective'"><span>{{ trans.get('mobile-menu.regular') }}</span></a>
        </li>
        <li class="list-item" v-if="hasActiveDiscounts">
          <a class="list-item__text" :href="routes['shop'] + '/offers'"><span>{{trans.get("layouts.header.offers")}}</span></a>
        </li>
        <li class="list-item">
          <a class="list-item__text" :href="routes['merchandise']+'/all'"><span>{{ trans.get('mobile-menu.merch') }}</span></a>
        </li>
         <li class="list-item">
          <a class="list-item__text seed-link" :href="routes['find-your-seed']"><span>{{ trans.get('layouts.header.find-your-seed') }}</span></a>
        </li>
      </ul>
    </div>
    <div class="lower-content">
      <ul class="list caps">
        <li class="list-item"><a class="font-bold" :href="routes.about">{{ trans.get('mobile-menu.about') }}</a></li>
        <li class="list-item"><a class="font-bold" :href="routes.contact">{{ trans.get('mobile-menu.contact') }}</a></li>
        <li class="list-item"><a class="font-bold" :href="routes['shipping-and-delivery']">{{ trans.get('mobile-menu.shipping-delivery') }}</a></li>
        <li class="list-item"><a class="font-bold" :href="routes['returns-policy']">{{ trans.get('mobile-menu.returns-policy') }}</a></li>
        <li class="list-item uppercase"><a class="font-bold" :href="routes.stores">{{ trans.get("mobile-menu.stores") }}</a></li>
        <li class="list-item"><a class="font-bold uppercase" :href="routes.faqs">{{ trans.get('mobile-menu.faqs') }}</a></li>
      </ul>
      <ul class="list lower-case">
        <li class="list-item items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g fill="none" fill-rule="evenodd">
              <g fill="#FFF" fill-rule="nonzero">
                <g>
                  <path
                    d="M16.41 0H6.09C2.733 0 0 2.732 0 6.09v10.32c0 3.358 2.732 6.09 6.09 6.09h10.32c3.358 0 6.09-2.732 6.09-6.09V6.09C22.5 2.733 19.768 0 16.41 0zm-5.16 17.402c-3.392 0-6.152-2.76-6.152-6.152 0-3.392 2.76-6.152 6.152-6.152 3.392 0 6.152 2.76 6.152 6.152 0 3.392-2.76 6.152-6.152 6.152zm6.3-10.853c-1.003 0-1.819-.816-1.819-1.818 0-1.003.816-1.818 1.818-1.818 1.003 0 1.818.815 1.818 1.818 0 1.002-.815 1.818-1.818 1.818z"
                    transform="translate(-27 -684) translate(27.579 684.305)"
                  />
                  <path
                    d="M11.25 6.417c-2.665 0-4.833 2.168-4.833 4.833s2.168 4.833 4.833 4.833 4.833-2.168 4.833-4.833-2.168-4.833-4.833-4.833zM17.55 4.232c-.276 0-.5.224-.5.499s.224.499.5.499c.274 0 .498-.224.498-.5 0-.274-.224-.498-.499-.498z"
                    transform="translate(-27 -684) translate(27.579 684.305)"
                  />
                </g>
              </g>
            </g></svg
          ><a href="https://www.instagram.com/hsceurope/"><span>Instagram</span></a>
        </li>
        <li class="list-item items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="17"
            viewBox="0 0 24 17"
          >
            <g fill="none" fill-rule="evenodd">
              <g fill="#FFF" fill-rule="nonzero">
                <g>
                  <g>
                    <path
                      d="M22.253 2.522c-.262-.974-1.03-1.74-2.003-2.003-1.778-.486-8.89-.486-8.89-.486S4.248.033 2.47.5C1.516.762.73 1.549.468 2.52 0 4.3 0 7.988 0 7.988s0 3.705.468 5.464c.262.974 1.03 1.741 2.003 2.003 1.796.487 8.89.487 8.89.487s7.111 0 8.89-.468c.972-.262 1.74-1.03 2.002-2.003.468-1.778.468-5.465.468-5.465s.018-3.705-.468-5.483zm-13.157 8.87V4.58l5.914 3.407-5.914 3.406z"
                      transform="translate(-27 -736) translate(27.579 731.853) translate(0 4.485)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <a href="https://www.youtube.com/channel/UC_OEVIRPI6KQcb2h3gsq93Q"><span>YouTube</span></a>
        </li>
      </ul>
      <ul class="list">
        <li class="list-item"><a :href="routes['legal-disclaimer']">{{ trans.get('mobile-menu.legal-disclaimer') }}</a></li>
        <li class="list-item"><a class="leading-5" :href="routes['privacy-policy']">{{ trans.get('mobile-menu.privacy-policy') }}</a>
        </li>
        <li class="list-item"><a class="leading-5" :href="routes['cookies-policy']">{{ trans.get('mobile-menu.cookies-policy') }}</a></li>
        <li class="list-item"><a :href="routes['limitation-of-liability']">{{ trans.get('mobile-menu.limitation-of-liability') }}</a></li>
      </ul>
      <slot name="language-selector-mobile"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_PRODUCTS_WITH_DISCOUNT
} from "../../store/shop/types";
export default {
    props: {
        routes: {
            type: Object,
            required: true,
        },
        username: {
            type: String,
            required: false,
        },
        closeMenu: {
          type: Function,
        },
        hasActiveDiscounts: {
          default: false,
          type: Boolean,
        }
    },
     computed: {
     ...mapGetters({
      discountProduct:GET_PRODUCTS_WITH_DISCOUNT
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";

.layout-menu {
  display: flex;
  flex-direction: column;

  .upper-content {
    background-color: $secondary;
    font-size: 18px;

    .logo-image {
      display: block;

      img {
        height: 42px;
        width: 100px;
      }
    }
    .seed-link {
      color: $yellow !important;
    }
    .list {
      color: $white;
      margin-top: 5px;
      font-weight: bold;
      &.caps {
        font-size: 18px;
      }
      &.loweer-case {
        font-size: 14px;
      }
      .list-item {
        height: 55px;
        &__text {
          align-items: center;
          display: flex;
          height: 100%;
          margin-right: 0px;
          color: $white;
          span {
            padding-left: 26px;
          }
          &.bordered {
            border-top: 1px solid $inactive-grey;
            border-bottom: 1px solid $inactive-grey;
          }
        }
        &.language-selector-mobile {
          padding-left: 26px;
          margin-right: 20px;
          height: 60px !important;
          border-top: 1px solid $inactive-grey;
          span {
            padding-left: 0;
          }

          a{
            color:$white;
          }
        }
      }
    }
  }

  .menu-close {
    font-size: 45px;
    background-color: transparent;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    .cross {
      width: 100%;
      text-align: center;
      font-size: 45px;
      color: white !important;
    }
  }

  .lower-content {
    background-color: #000000;
    padding: 10px 27px;
    color: $white !important;

    .list {
      padding: 12px 0;
      &-item {
        padding: 8px 0;
        display: flex;

        a {
          color: white !important;
        }
        span {
          margin-left: 12px;
        }
      }
    }
  }
}
</style>
